import { CodeBase } from "./_codeBase";

/** 立会作業項目SKY-AiR連携区分*/
export class SkyAirIntegrationDiv extends CodeBase<SkyAirIntegrationDiv>
{
    /** 立会作業項目SKY-AiR連携区分: "01", ""*/
    public static readonly NONE: SkyAirIntegrationDiv = new SkyAirIntegrationDiv("01", "", "");
    /** 立会作業項目SKY-AiR連携区分: "02", "立会"*/
    public static readonly ATTENDANT: SkyAirIntegrationDiv = new SkyAirIntegrationDiv("02", "立会", "");
    /** 立会作業項目SKY-AiR連携区分: "03", "特殊作業"*/
    public static readonly SPECIAL: SkyAirIntegrationDiv = new SkyAirIntegrationDiv("03", "特殊作業", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): SkyAirIntegrationDiv[] {
        return [
            SkyAirIntegrationDiv.NONE,
            SkyAirIntegrationDiv.ATTENDANT,
            SkyAirIntegrationDiv.SPECIAL,
        ];
    }
}
